import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-delete\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 416v448a32 32 0 0 1-32 32H288a32 32 0 0 1-32-32V416a32 32 0 0 0-64 0v448a96.11 96.11 0 0 0 96 96h448a96.11 96.11 0 0 0 96-96V416a32 32 0 0 0-64 0z\" p-id=\"2681\" /><path d=\"M864 192H672v-32a96.11 96.11 0 0 0-96-96H448a96.11 96.11 0 0 0-96 96v32H160a96 96 0 0 0 0 192h704a96 96 0 0 0 0-192z m-448-32a32 32 0 0 1 32-32h128a32 32 0 0 1 32 32v32H416v-32z m448 160H160a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64zM352 800a32 32 0 0 0 32-32V512a32 32 0 0 0-64 0v256a32 32 0 0 0 32 32zM672 800a32 32 0 0 0 32-32V512a32 32 0 0 0-64 0v256a32 32 0 0 0 32 32zM512 800a32 32 0 0 0 32-32V512a32 32 0 0 0-64 0v256a32 32 0 0 0 32 32z\" p-id=\"2682\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delete.svg
// module id = Imjp
// module chunks = 101